
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { WorkflowCommonMixin } from ".";
import { ReceptionReference, ReceptionCommentDispInfo, ReceptionDetailPermissions } from "../../../domain/workflow/reference";
import { ReceptionCommentSet } from "../../../domain/workflow/reception";
import { ReceptionDispInfo } from "../../../domain/workflow";
import { ReceptionListDispInfoBase } from "../../../domain/workflow/base";
import { ReceptionDetailSummary } from "../../../domain/workflow/list";
import { ButtonInfo } from "../../../domain/workflow/items";
import { ReceptionReferenceKinds } from "../../../domain/workflow/kinds";

@Component({
})
/**
 * ワークフロー一覧（管理者向け・記載者向け）画面用BaseMixin
 */
export default class WorkflowListBaseMixin extends Mixins(WorkflowCommonMixin) {

  @Prop()
  isAdmin: boolean;

  @Prop()
  paramPatientNo: string;

  @Prop()
  paramReceptionDetailId: number;

  data(): any {
    return {
      overLimitMessage: null,
      detailList: [],
      selectedDetail: null as ReceptionDetailSummary,
      detailId: null as number,
      
      reference: null as ReceptionReference,
      loadingReferenceSource: null as number,
      isShowPreview: true,
      isLoading: false,
      isRegistering: false,

      displaySetting: null,
    };
  }
  overLimitMessage: string;
  detailList: ReceptionDetailSummary[];
  selectedDetail: ReceptionDetailSummary;

  detailId: number;
  reference: ReceptionReference;

  isShowPreview: boolean;
  isLoading: boolean;
  isRegistering: boolean;
  loadingReferenceSource: number;

  displaySetting: ReceptionListDispInfoBase;

  mounted(): void {
  }

  @Watch("selectedDetail")
  onSelectedDetailUpdated(newValue: ReceptionDetailSummary, oldValue: ReceptionDetailSummary): void {
    if (!newValue) {
      this.detailId = null;
      this.reference = null;
      this.loadingReferenceSource = null;
      // TODO 選択クリアされた場合、detailsもからに
    } else {
      if (!oldValue || (oldValue && newValue.id !== oldValue.id)) {
        this.detailId = newValue.id;
        this.getDetail(newValue.id);
      }
    }
  }

  reloadDetail() {
    if (this.detailId) {
      this.getDetail(this.detailId);
    }
  }

  // ------------------コメント----------------------------

  get labelSetting(): ReceptionDispInfo {
    return this.displaySetting ? this.displaySetting.labelSetting : null;
  }

  get commentSetting(): ReceptionCommentDispInfo {
    return this.displaySetting ? this.displaySetting.commentSetting : null;
  }

  get loadChunkSize(): number {
    return this.displaySetting ? this.displaySetting.loadingChunkSize : 50;
  }

  get generalFlag1LabelName(): string {
    return this.displaySetting ? this.displaySetting.labelSetting.generalFlag1LabelName : "";
  }

  get isGeneralFlag1Enable(): boolean {
    return this.labelSetting ? this.labelSetting.isGeneralFlag1Visible : true;
  }

  get generalFlag1(): boolean {
    return this.reference ? this.reference.reception.delivery.generalFlag1 : false;
  }

  get isInOutTypeEnable(): boolean {
    return this.labelSetting && this.labelSetting.isInOutTypeVisible;
  }

  get isRegistered(): boolean {
    return !!this.reference;
  }

  get isReferenceLoading(): boolean {
    return !!this.loadingReferenceSource;
  }

  get isDeleted(): boolean {
    return this.reference ? this.reference.receptionDetail.deleted : false;
  }

  get commentSet(): ReceptionCommentSet {
    return this.reference ? this.reference.receptionDetail.commentSet : new ReceptionCommentSet();
  }

  // --------------依頼詳細用ボタン------------------------

  get permissions(): ReceptionDetailPermissions {
    return this.reference ? this.reference.displayInfo.permissions : null;
  }

  get editDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.edit : null;
  }

  get permittedEditDetail(): boolean {
    return this.editDetailPermission ? this.editDetailPermission.isPermitted : false;
  }

  // -------------------表示用---------------------------------

  get isPaperNameEnable(): boolean {
    return this.labelSetting && this.labelSetting.isPaperNameVisible;
  }

  get isPaperCompanyNameEnable(): boolean {
    return this.labelSetting && this.labelSetting.isPaperCompanyNameVisible;
  }

  get defaultSelectedContentTab(): ReceptionReferenceKinds {
    return (this.displaySetting && this.displaySetting.defaultSelectedContentTab)
      ? this.displaySetting.defaultSelectedContentTab
      : ReceptionReferenceKinds.Document;
  }

  // -------------------Emitで呼ばれる---------------------------------

  // 子どもからコメント更新通知がきました
  onCommentUpdated(): void {
    this.$logger.debug("onCommentUpdated");
    if (this.detailId) {
      this.getDetail(this.detailId);
    }
  }

  // コメントダイアログOpen通知を受け取りました
  hidePreview() {
    if (this.isIE()) {
      this.isShowPreview = false;
    }
  }

  // コメントダイアログClose通知を受け取りました
  showPreview() {
    if (this.isIE()) {
      this.isShowPreview = true;
    }
  }

  // --------------------API通信-----------------------------------

  // 依頼詳細取得
  async getDetail(receptionDetailId: number): Promise<void> {
    try {
      // 要求中の依頼詳細と同じものは要求しないようにする
      if (this.loadingReferenceSource !== receptionDetailId) {
        const repository = DomainRegistry.workflow.getWorkflowRepository();
        this.loadingReferenceSource = receptionDetailId;
        const result = await repository.getReceptionDetailReference(receptionDetailId);

        if (this.loadingReferenceSource === receptionDetailId) {
          this.reference = result;
          this.loadingReferenceSource = null;
        }
      }
    } catch (e) {
      this.loadingReferenceSource = null;
      this.showRequestErrorMessage("エラー", "ワークフローの取得に失敗しました。", e);
    }
  }

  async getDetailWithoutLoading(receptionDetailId: number): Promise<ReceptionReference> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      return await repository.getReceptionDetailReference(receptionDetailId);
    } catch (e) {
      console.debug("getDetailWithoutLoading is failed.");
      return null;
    }
  }

  // --------------------メソッド-----------------------------------

  clearSearchResult(): void {
    // 検索前にリストを空に（メモリ対策）
    this.detailList = [];
    this.overLimitMessage = null;

    // // 今選択状態の受付IDをバックアップ
    // this.preReceptionId = this.selectedReception ? this.selectedReception.id : null;
    // 依頼詳細を未選択状態に
    this.reference = null;
  }

  setDetailList(list: ReceptionDetailSummary[], shouldSelectFirst: boolean): void {
    // view側で実装
  }

}
